export const marginTopIcon = `
<svg fill="currentColor"  xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    <g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/>
        <path stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 12.5h12M6 18.5h12"/>
        <path fill="currentcolor" d="m11.408 5.35-1.73 2.733c-.296.467.074 1.051.665 1.051h3.46c.592 0 .962-.584.667-1.05L12.739 5.35c-.296-.467-1.035-.467-1.331 0"/>
    </g>
</svg>
`;
export const marginBottomIcon = `
<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    <g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/>
        <path stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 11.5H6M18 5.5H6"/>
        <path fill="currentcolor" d="m12.592 18.65 1.73-2.733c.296-.467-.074-1.051-.665-1.051h-3.46c-.592 0-.962.584-.667 1.05l1.731 2.734c.296.467 1.035.467 1.331 0"/>
    </g>
</svg>
`;
//# sourceMappingURL=icon.js.map